import { useTranslation } from 'next-i18next';
import React, { useContext, VFC } from 'react';

import {
  SortParam,
  SortParamProfile,
} from '@/containers/MarketplacePage/interface';
import MarketplaceItemsContext from '@/contexts/MarketplaceItemsContext';

import styles from './SortSelect.module.scss';
type props = {
  isShowingNFTs: boolean;
};
const SortSelect: VFC<props> = (props: props) => {
  const { t } = useTranslation();

  const {
    searchConditionNFTs,
    setSearchConditionNFTs,
    searchConditionUsers,
    setSearchConditionUsers,
  } = useContext(MarketplaceItemsContext);
  /*const {searchConditionUsers, setSearchConditionUsers} = useContext(
    MarketplaceItemsContext
  );*/

  const NFTOptions: {
    [key in SortParam]: string;
  } = {
    [SortParam.ListedAtDesc]: t('filterSidebar.sort.select.listedAtDesc'),
    [SortParam.ListedAtAsc]: t('filterSidebar.sort.select.listedAtAsc'),
    [SortParam.PriceDesc]: t('filterSidebar.sort.select.priceDesc'),
    [SortParam.PriceAsc]: t('filterSidebar.sort.select.priceAsc'),
    [SortParam.CreatedAtDesc]: t('filterSidebar.sort.select.createdAtDesc'),
    [SortParam.CreatedAtAsc]: t('filterSidebar.sort.select.createdAtAsc'),
  };
  const ProfileOptions: {
    [key in SortParamProfile]: string;
  } = {
    [SortParamProfile.creationCountAsc]: t(
      'filterSidebar.sort.select.creationCountAsc'
    ),
    [SortParamProfile.creationCountDesc]: t(
      'filterSidebar.sort.select.creationCountDesc'
    ),
    [SortParamProfile.salesAsc]: t('filterSidebar.sort.select.salesAsc'),
    [SortParamProfile.salesDesc]: t('filterSidebar.sort.select.salesDesc'),
    [SortParamProfile.profileCreationDateAsc]: t(
      'filterSidebar.sort.select.profileCreationDateAsc'
    ),
    [SortParamProfile.profileCreationDateDesc]: t(
      'filterSidebar.sort.select.profileCreationDateDesc'
    ),
    [SortParamProfile.collectionCountAsc]: t(
      'filterSidebar.sort.select.collectionCountAsc'
    ),
    [SortParamProfile.collectionCountDesc]: t(
      'filterSidebar.sort.select.collectionCountDesc'
    ),
    // [SortParamProfile.purchaseCountAsc]: t(
    //   'filterSidebar.sort.select.purchaseCountAsc'
    // ),
    // [SortParamProfile.purchaseCountDesc]: t(
    //   'filterSidebar.sort.select.purchaseCountDesc'
    // ),
  };

  const selectOptions = props.isShowingNFTs ? NFTOptions : ProfileOptions;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (props.isShowingNFTs) {
      const newSearchConditionNFTs = {
        ...searchConditionNFTs,
        sort: e.target.value as SortParam,
      };
      setSearchConditionNFTs(newSearchConditionNFTs);
    } else {
      const newSearchConditionUsers = {
        ...searchConditionUsers,
        sort: e.target.value as SortParamProfile,
      };
      setSearchConditionUsers(newSearchConditionUsers);
    }
  };

  return (
    <div className={styles.selectWrapper}>
      <select
        value={
          props.isShowingNFTs
            ? searchConditionNFTs.sort
            : searchConditionUsers.sort
        }
        onChange={handleChange}
        className={styles.sortSelect}
      >
        {Object.entries(selectOptions).map(([key, label]) => (
          <option value={key} key={key}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SortSelect;
